import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditSetColumnDialogComponent } from './edit-set-column-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from '../../../app/app-material/app-material.module';

@NgModule({
  declarations: [EditSetColumnDialogComponent],
  imports: [AppMaterialModule, CommonModule, FormsModule, ReactiveFormsModule],
  entryComponents: [EditSetColumnDialogComponent]
})
export class EditSetColumnDialogModule {}
